// This is to escape all HTML encoded chars eg: convert &#64; to %23
const getEscapedOrderNumber = (rawOrderNumber) =>
  encodeURIComponent(
    rawOrderNumber.replace(/&#([0-9]{1,3});/gi, (match, entity) => {
      const asciiCode = parseInt(entity, 10);
      return String.fromCharCode(asciiCode);
    }),
  );

export default getEscapedOrderNumber;
